import PropTypes from 'prop-types';

import AppDialog from '#/modules/commonComponents/dialog/AppDialog';
import { dialog3xlMaxWidthClassName } from '#/modules/commonComponents/dialog/dialogLayoutTokens';

import RepairRequestCorrectionHistoryList from './RepairRequestCorrectionHistoryList';

/** 側欄用：更正紀錄 dialog（詳情頁改用下方分頁）。 */
const RepairRequestCorrectionHistoryDialog = ({ open, onOpenChange, detail }) => (
  <AppDialog
    open={open}
    onOpenChange={onOpenChange}
    title="更正紀錄"
    description="僅內部可見；客戶查詢只顯示目前資料。"
    maxWidthClassName={dialog3xlMaxWidthClassName}
  >
    <RepairRequestCorrectionHistoryList detail={detail} enabled={open} className="pt-4" />
  </AppDialog>
);

RepairRequestCorrectionHistoryDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  detail: PropTypes.shape({
    id: PropTypes.string,
    lines: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
};

export default RepairRequestCorrectionHistoryDialog;
